import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Button, 
  Paper, 
  Stack 
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HomeIcon from '@mui/icons-material/Home';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const NotFoundPage: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper 
        elevation={0}
        sx={{ 
          p: { xs: 4, md: 6 }, 
          textAlign: 'center',
          borderRadius: 3,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <ErrorOutlineIcon 
          sx={{ 
            fontSize: { xs: 60, md: 80 }, 
            color: 'error.main',
            mb: 2 
          }} 
        />
        
        <Typography 
          variant="h1" 
          component="h1" 
          color="text.primary"
          sx={{ 
            fontWeight: 700, 
            fontSize: { xs: '3rem', md: '4rem' },
            mb: 2 
          }}
        >
          404
        </Typography>
        
        <Typography 
          variant="h4" 
          component="h2"
          color="text.primary" 
          sx={{ 
            fontWeight: 500,
            mb: 2 
          }}
        >
          Page Not Found
        </Typography>
        
        <Typography 
          variant="body1" 
          color="text.secondary"
          sx={{ 
            mb: 4,
            maxWidth: '600px',
            mx: 'auto'
          }}
        >
          The page you are looking for might have been removed, had its name changed, 
          or is temporarily unavailable.
        </Typography>
        
        <Stack 
          direction={{ xs: 'column', sm: 'row' }} 
          spacing={2} 
          justifyContent="center"
        >
          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<HomeIcon />}
            component={RouterLink}
            to="/"
            sx={{ borderRadius: 2 }}
          >
            Back to Home
          </Button>
          
          <Button
            variant="outlined"
            color="primary"
            size="large"
            startIcon={<ArrowBackIcon />}
            onClick={() => window.history.back()}
            sx={{ borderRadius: 2 }}
          >
            Go Back
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
};

export default NotFoundPage; 